export default "__VITE_ASSET__e5fc9ac1__"